import {
  Anchor,
  Button,
  Checkbox,
  Container,
  Group,
  Paper,
  PasswordInput,
  Text,
  TextInput,
  em,
  Center,
  Stack,
} from '@mantine/core';
import { useForm } from '@mantine/form';
import { useNavigate, Link } from 'react-router-dom';
import { validateEmail } from '../utils/validateEmail';
import { authenticatePassword } from '../utils/validatePassword';
import { login } from '../store/actions/authActions';
import Logo from '../assets/img/Logo_Consili18.svg';
import { theme } from '../consilitheme';
import { useDispatch } from 'react-redux';
import { useLazyLoginQuery } from '../endpoints/user';
import { useEffect, useState } from 'react';
import { ThreeCircles } from 'react-loader-spinner';
import { useUserQuery } from '../endpoints/user';

const Login = () => {
  const user = useUserQuery();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const form = useForm({
    validateInputOnChange: true,
    initialValues: {
      email: '',
      password: '',
    },
    validate: {
      email: validateEmail,
      // password isnt here because we don't want to hint what is a valid password
    },
  });
  const [getAuthenticated] = useLazyLoginQuery();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!user.isLoading && user.isSuccess) {
      navigate('/home');
    }
  }, [user]);

  const handleLogin = async (values) => {
    const authStatus = authenticatePassword(values.password);
    if (authStatus === 'authenticated') {
      dispatch(
        login({
          email: values.email,
          demoAnimation: false,
          data: 'default',
        })
      );
    } else if (authStatus === 'demo') {
      dispatch(
        login({
          email: values.email,
          demoAnimation: false,
          data: 'default',
        })
      );
    } else if (authStatus === 'demoAnimation') {
      dispatch(
        login({
          email: values.email,
          demoAnimation: true,
          data: 'default',
        })
      );
    } else if (authStatus === 'demoCybertruck') {
      dispatch(
        login({
          email: values.email,
          demoAnimation: true,
          data: 'cybertruck',
        })
      );
    } else {
      dispatch(
        login({
          email: values.email,
          demoAnimation: false,
          data: 'custom',
        })
      );
    }

    try {
      setIsLoading(true);
      await getAuthenticated({
        username: values.email,
        password: values.password,
      }).unwrap();
      setIsLoading(false);

      navigate('/home');
      return;
    } catch (error) {
      alert('Invalid credentials');
      setIsLoading(false);
    }
  };

  return (
    <Container size={420} my={40}>
      <Center>
        <a href="https://consili.io/" rel="noreferrer">
          <img
            style={{
              paddingBottom: theme.padding.lg,
              cursor: 'pointer',
              width: `calc(350px - ${em(60)})`,
            }}
            src={Logo}
            radius="md"
          />
        </a>
      </Center>
      <Text color="dimmed" size="sm" align="center" mt={5}>
        Do not have an account yet?{' '}
        <Link to="../register">
          <Anchor component="button" size="sm">
            Create account
          </Anchor>
        </Link>
      </Text>
      {isLoading ? (
        <Stack
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
          }}
        >
          {' '}
          <ThreeCircles
            visible={true}
            height="100"
            width="100"
            color={theme.colors.blue[4]}
            ariaLabel="three-circles-loading"
            wrapperStyle={{}}
            wrapperClass=""
          />{' '}
          <Text
            color={theme.colors.blue[3]}
            size="md"
            align="center"
            mt={10}
            fw={600}
          >
            {' '}
            Consili is logging you in...
          </Text>
        </Stack>
      ) : (
        <Paper withBorder shadow="md" p={30} mt={30} radius="md">
          <form onSubmit={form.onSubmit(handleLogin)}>
            <TextInput
              label="Email"
              placeholder="you@consili.dev"
              required
              {...form.getInputProps('email')}
            />
            <PasswordInput
              label="Password"
              placeholder="Your password"
              required
              mt="md"
              {...form.getInputProps('password')}
            />
            <Group position="apart" mt="lg">
              <Checkbox label="Remember me" />
              <Anchor component="button" size="sm" ml="auto">
                Forgot password?
              </Anchor>
            </Group>
            <Button fullWidth mt="xl" type="submit">
              Sign in
            </Button>
          </form>
        </Paper>
      )}
    </Container>
  );
};

export default Login;
